import { Dialog } from "@headlessui/react";
import { useForm } from "react-hook-form";
import { useState, useEffect } from "react";
import DialogBackdrop from "components/ModalDialogs/DialogBackdrop";
import { getConsentPDFContent } from "service/userservice/getConsentPDFContent";
import LoadingOverlay from "react-loading-overlay";
import { useTranslation } from "react-i18next";
import config from "config/config";

export default function EConsentDialog({
  showEConsentDialog,
  setshowEConsentDialog,
  resetSelection,
}) {
  const { t } = useTranslation();
  const { setValue, watch, reset } = useForm({
    defaultValues: { agree: false },
  });
  const [consentContent, setConsentContent] = useState();
  const [previousItems, setPreviousItems] = useState(showEConsentDialog);

  if (showEConsentDialog !== previousItems) {
    setPreviousItems(showEConsentDialog);
    reset();
  }

  LoadingOverlay.propTypes = undefined;
  const consentAccepted = watch("agree");

  useEffect(() => {
    econsentPDFContent();
  }, []);

  const econsentPDFContent = async () => {
    await getConsentPDFContent(
      config.COMPANY_NAME === "everlake"
        ? "EL_Electronic_Consent_June2023.html"
        : "Electronic_Consent_June2023.html",
      "inline"
    )
      .then((consentPDFContent) => {
        setConsentContent(consentPDFContent);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <Dialog open={showEConsentDialog} onClose={() => {}} className="ui-dialogs">
      <DialogBackdrop />
      {/* Full-screen container to center the panel */}
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel
          role="dialog"
          aria-modal="true"
          className="ui-default-dialog"
        >
          <Dialog.Title className="sr-only">
            {t("EConsentDialog-title")}
          </Dialog.Title>
          <hr />
          <form>
            <div className="ui-grid-manage-notification" key="keyFieldset">
              <div id="divpdfcontent" className="h-[400px] overflow-scroll">
                <iframe
                  className="h-[1750px] w-[600px] overflow-hidden"
                  title="test"
                  srcDoc={consentContent}
                />
                <label className="ui-checkbox">
                  <input
                    id="selectIAgree"
                    key="selectIAgree"
                    type="checkbox"
                    onChange={(e) => {
                      setValue("agree", e.target.checked);
                    }}
                  />
                  <div className="ui-checkmark mx-2">
                    <svg
                      className="ui-icon w-2 h-2 text-white"
                      focusable="false"
                      aria-hidden="true"
                      role="presentation"
                    >
                      <use href="#ui-icon-checkmark"></use>
                    </svg>
                  </div>
                  {t("EConsentDialog-agrement")}
                </label>
              </div>
              <hr className="ui-no-margins col-span-4" />
            </div>
            {/* <!-- Buttons --> */}
            <div className="block text-right mt-6">
              <button
                type="button"
                className="ui-btn-secondary ui-btn-min-w mt-4"
                onClick={() => {
                  setshowEConsentDialog(false);
                  resetSelection("cancel");
                }}
              >
                {t("EConsentDialog-cancel")}
                <span className="sr-only">Cancel and close consent</span>
              </button>
              <button
                className="ui-btn-primary ui-btn-min-w mt-4"
                id="ID_Agree"
                disabled={!consentAccepted}
                onClick={() => {
                  setshowEConsentDialog(false);
                  resetSelection("accept");
                }}
              >
                {t("EConsentDialog-agree")}
                <span className="sr-only">Agree and close consent</span>
              </button>
            </div>
          </form>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}
